module.exports = __webpack_public_path__ + "img/xitong.297b228b.png";